"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferContentItemFieldKey = (block, contentItem) => {
    if (!contentItem) {
        console.error('No content item passed to inferContentItemFieldKey');
        return null;
    }
    if (block.type === 'group' || block.type === 'repeater') {
        return null;
    }
    const keys = Object.keys(contentItem);
    const attrs = block.attrs || {};
    // In the template, the user can specify an attr that will tell Osmosys where in a particular content mapping to pull content from
    const explicitlySetSourceName = attrs['osys:field:source']; // TODO: Trim might not be needed/wanted
    if (explicitlySetSourceName && keys.includes(explicitlySetSourceName)) {
        return explicitlySetSourceName;
    }
    return (keys.find((key) => {
        // Generic fields ('text' | 'url' | 'html' | 'datetime') may exist on the content item, so try and use those if possible,
        // since the liklihood that they line up to the mapping are higher than 0.
        if (!contentItem[key] || !contentItem[key].type) {
            return false;
        }
        if (block.fieldType && contentItem[key].type === block.fieldType) {
            return true;
        }
        if (block.fieldTypes &&
            block.fieldTypes.includes(contentItem[key].type)) {
            return true;
        }
        return false;
    }) ||
        Object.keys(contentItem)[0] ||
        'title');
};
// Old code:
// import { EmailTemplateBlock, IContentItem } from '@osmosys/types';
// export const inferContentItemFieldKey = (
//   block: EmailTemplateBlock,
//   contentItem: IContentItem
// ): string => {
//   const keys = Object.keys(contentItem);
//   const attrs = block.attrs || {};
//   // In the template, the user can specify an attr that will tell Osmosys where in a particular content mapping to pull content from
//   const explicitlySetSourceName = attrs['osys:field:source']; // TODO: Trim might not be needed/wanted
//   if (explicitlySetSourceName && keys.includes(explicitlySetSourceName)) {
//     return explicitlySetSourceName;
//   }
//   return (
//     keys.find((key: string) => {
//       // Generic fields ('text' | 'url' | 'html' | 'datetime') may exist on the content item, so try and use those if possible,
//       // since the liklihood that they line up to the mapping are higher than 0.
//       if (!contentItem[key] || !contentItem[key].type) {
//         return false;
//       }
//       if (block.fieldType && contentItem[key].type === block.fieldType) {
//         return true;
//       }
//       if (
//         block.fieldTypes &&
//         block.fieldTypes.includes(contentItem[key].type)
//       ) {
//         return true;
//       }
//       return false;
//     }) ||
//     Object.keys(contentItem)[0] ||
//     'title'
//   );
// };
//# sourceMappingURL=inferContentItemFieldKey.js.map